var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('datetime',{staticClass:"caption",attrs:{"placeholder":"no value","type":"date","value":_vm._f("iso8601")(_vm.value),"input-style":_vm.inputStyle},on:{"input":function($event){return _vm.onInput($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }